export const HISTORY_DETAIL_START = 'HISTORY_DETAIL_START';
export const HISTORY_DETAIL_SUCCESS = 'HISTORY_DETAIL_SUCCESS';
export const HISTORY_DETAIL_FAIL = 'HISTORY_DETAIL_FAIL';

export const CREATE_HISTORY_START = 'CREATE_HISTORY_START';
export const CREATE_HISTORY_SUCCESS = 'CREATE_HISTORY_SUCCESS';
export const CREATE_HISTORY_FAIL = 'CREATE_HISTORY_FAIL';

export const TRIGGERS_DETAIL_START = 'TRIGGERS_DETAIL_START';
export const TRIGGERS_DETAIL_SUCCESS = 'TRIGGERS_DETAIL_SUCCESS';
export const TRIGGERS_DETAIL_FAIL = 'TRIGGERS_DETAIL_FAIL';

export const CREATE_TRIGGER_START = 'CREATE_TRIGGER_START';
export const CREATE_TRIGGER_SUCCESS = 'CREATE_TRIGGER_SUCCESS';
export const CREATE_TRIGGER_FAIL = 'CREATE_TRIGGER_FAIL';

export const TRIGGERS_SLUG_START = 'TRIGGERS_SLUG_START';
export const TRIGGERS_SLUG_SUCCESS = 'TRIGGERS_SLUG_SUCCESS';
export const TRIGGERS_SLUG_FAIL = 'TRIGGERS_SLUG_FAIL';
